import { apiClient } from '../../config/axios-client'
import type {
  ApplyImageStyleParams,
  ImageStyleBatchResult,
} from '../../shared/models/ImageStyleBatch'
import type { Storyboard } from '../../shared/models/Storyboard'
import type { GenerateStoryboardParams } from '../types/GenerationParams'

export const storyboardsApi = {
  applyStyle: (commercialId: string, params: ApplyImageStyleParams) =>
    apiClient.post<ImageStyleBatchResult>(`commercials/${commercialId}/storyboards/apply-style`, {
      imageIds: [...new Set(params.imageIds)],
      imageStylePromptIds: [...new Set(params.imageStylePromptIds)],
      ...(params.imageProvider && { imageProvider: params.imageProvider }),
      ...(params.quality && { quality: params.quality }),
      ...(params.numberOfImages !== undefined && { numberOfImages: params.numberOfImages }),
    }),
  generate: (commercialId: string, params: GenerateStoryboardParams) =>
    apiClient.post<unknown>(`commercials/${commercialId}/storyboards/generate`, params),

  detail: (commercialId: string) =>
    apiClient.get<Storyboard>(`commercials/${commercialId}/storyboards`),

  export: (commercialId: string) =>
    apiClient.post<Blob>(`commercials/${commercialId}/storyboards/export`, null, {
      responseType: 'blob',
    }),
}
